<script setup>
import { ref, computed } from "vue";
import TrashCan from "@/components/shared/icons/TrashCan.vue";
import { defineEmits, watch, toRefs } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
  row: {
    type: Object,
    required: false,
    default: {},
  },
});

const { row } = toRefs(props);

const individualCardData = ref({
  ...row.value,
});

const rules = computed(() => ({
  homeClassId: { required },
}));

const v$ = useVuelidate(rules, individualCardData);

const validateFields = () => {
  v$.value.$touch();
  return !v$.value.$invalid;
};

defineExpose({ validateFields });

watch(
  [row],
  () => {
    individualCardData.value.vueId = row.value.vueId;
  },
  { immediate: true }
);

const emit = defineEmits(["delete", "individualCardDataBus", "validation"]);

watch(
  individualCardData,
  () => {
    emit("individualCardDataBus", individualCardData);
    emit("validation", {
      id: individualCardData.value.vueId,
      isValid: !v$.value.$invalid,
    });
  },
  { deep: true, immediate: true }
);

const deleteCourse = () => {
  emit("delete", props.row.vueId);
};
</script>

<template>
  <div class="w-full px-6 pb-6 rounded-md">
    <div class="flex flex-col p-5 rounded-lg bg-purple-50 border-l-8 border-purple-700 space-y-4">
      <div class="flex justify-between">
        <h2 class="text-lg font-semibold text-university-primary">My Course #{{ index + 1 }}</h2>
        <button
          class="flex items-center text-university-secondary hover:text-teal-300"
          aria-label="Add Another"
          @click="deleteCourse"
        >
          <TrashCan />
        </button>
      </div>

      <div>
        <label class="font-semibold pb-2 text-university-primary block" for="equivalent-course">
          <span class="text-red-100 pr-2">**</span>My Equivalent Course #
        </label>
        <input
          id="equivalent-course"
          v-model="individualCardData.homeClassId"
          type="text"
          placeholder="Enter equivalent course"
          class="w-full p-3 border border-gray-300 bg-white rounded-md text-sm outline-none focus:border-purple-700"
          :class="{ 'border-red-500': v$.homeClassId.$error }"
          @blur="v$.homeClassId.$touch()"
        />
        <div v-if="v$.homeClassId.$error" class="text-red-500 text-sm mt-1">
          Please enter an equivalent course
        </div>
      </div>

      <div>
        <label class="font-semibold pb-2 text-university-primary block" for="course-name">
          My Course Name
        </label>
        <input
          id="course-name"
          v-model="individualCardData.homeClassTitle"
          type="text"
          placeholder="Enter course name"
          class="w-full p-3 border border-gray-300 bg-white rounded-md text-sm outline-none focus:border-purple-700"
        />
      </div>

      <div>
        <label class="font-semibold pb-2 text-university-primary block" for="count-as">
          Count As
        </label>
        <input
          id="count-as"
          v-model="individualCardData.comments"
          type="text"
          placeholder="Enter count as"
          class="w-full p-3 border border-gray-300 bg-white rounded-md text-sm outline-none focus:border-purple-700"
        />
      </div>
    </div>
  </div>
</template>
